
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Network } from 'lucide-react';
import { SidebarItem } from './sidebar-item';
import { useAdminAuth } from '@/hooks/use-admin-auth';

export const ArchitectureButton: React.FC = () => {
  const location = useLocation();
  const { isAdmin } = useAdminAuth();

  if (!isAdmin) {
    return null;
  }

  return (
    <SidebarItem
      href="/architecture"
      icon={<Network className="h-5 w-5" />}
      title="Arkitektur"
      isActive={location.pathname === "/architecture"}
    />
  );
};
